import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import { CLASS_NAME_RECENT_CV_BANNERS_WRAPPER } from '@xing-com/crate-jobs-domain-apply-constants';
import { GridContainer as GridContainerComponent } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  space3XL,
  spaceL,
  spaceM,
  spaceXL,
  spaceXS,
  spaceXXL,
  xdlColorBackgroundTertiary,
  xdlColorText,
} from '@xing-com/tokens';
import { Meta as MetaComponent } from '@xing-com/typography';

import { StyledListItem } from '../../uploads-list/uploads-list.styles';

const addSubsequentSiblingCombinatorWithTopMargin = (): string => {
  return `~ .${CLASS_NAME_RECENT_CV_BANNERS_WRAPPER} {margin-top: -${spaceXL}}`;
};

export const UploadButton = styled(Button)`
  margin-top: ${spaceL};
  width: 100%;

  @media ${mediaConfined} {
    margin-top: 0;
    display: flex;
    margin-left: auto;
    width: auto;
  }
`;

export const GridContainer = styled(GridContainerComponent)`
  margin-bottom: ${spaceXXL};
`;

export const ReducedUploadButton = styled(TextButton)`
  height: auto;
`;

export const ErrorBannerWrapper = styled.div<{
  $isReduced: boolean;
}>`
  margin-top: ${({ $isReduced }) => ($isReduced ? spaceXL : 0)};
  margin-bottom: ${({ $isReduced }) => ($isReduced ? 0 : space3XL)};

  ${addSubsequentSiblingCombinatorWithTopMargin()};
`;

export const UploadsListContainer = styled.div<{
  $isReduced: boolean;
}>`
  margin-top: ${({ $isReduced }) => ($isReduced ? spaceXL : 0)};
  margin-bottom: ${({ $isReduced }) => ($isReduced ? 0 : space3XL)};

  ${StyledListItem} {
    background: ${xdlColorBackgroundTertiary};

    &:not(:first-child) {
      margin-top: ${spaceL};
    }
  }

  ${addSubsequentSiblingCombinatorWithTopMargin()};
`;

export const Meta = styled(MetaComponent)`
  align-items: center;
  display: flex;
  gap: ${spaceXS};
  padding-top: ${spaceM};

  && {
    color: ${xdlColorText};
  }
`;

export const UploadDocsBannerWrapper = styled.div<{
  $hasPreviousErrorBanner: boolean;
}>`
  margin-top: ${({ $hasPreviousErrorBanner }) =>
    $hasPreviousErrorBanner ? `-${spaceXL}` : 0};
  margin-bottom: ${space3XL};

  ${addSubsequentSiblingCombinatorWithTopMargin()};
`;

export const AriaMessage = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
